import React from 'react';
import { PricingVariant } from '@wix/ambassador-pricing-plans-v3-plan/types';
import { VIEWER_HOOKS } from '@wix/pricing-plans-common/hooks';
import { Button, ButtonPriority, HoverStyles, PaddingModes } from '@wix/wix-ui-tpa/cssVars';
import { VariantCategoryNameById } from '../../../../../utils/variant-categories';
import { st, classes, vars } from './VariantToggle.st.css';

interface VariantToggleProps {
  variants: PricingVariant[];
  variantCategoryNameById: VariantCategoryNameById;
  selectedVariantId: string;
  onSelect(variant: PricingVariant): void;
}

export const VariantToggle: React.FC<VariantToggleProps> = ({
  variants,
  variantCategoryNameById,
  selectedVariantId,
  onSelect,
}) => {
  const selectedIndex = variants.findIndex((variant) => variant.id === selectedVariantId);
  const lastIndex = variants.length - 1;

  return (
    <div
      className={classes.root}
      data-hook={VIEWER_HOOKS.PLAN_VARIANT_TOGGLE}
      style={{ [vars.optionCount]: variants.length, [vars.selectedIndex]: selectedIndex } as React.CSSProperties}
    >
      <span
        aria-hidden="true"
        className={st(classes.selectedIndicator, {
          isFirst: selectedIndex === 0,
          isLast: selectedIndex === lastIndex,
        })}
      />
      {variants.map((variant) => {
        const isSelected = variant.id === selectedVariantId;
        const categoryId = variant.categoryIds?.find((id) => variantCategoryNameById[id]);
        const label = categoryId ? variantCategoryNameById[categoryId] : '';

        return (
          <Button
            key={variant.id}
            upgrade
            paddingMode={PaddingModes.explicitPaddings}
            hoverStyle={HoverStyles.colorChange}
            aria-pressed={isSelected}
            priority={isSelected ? ButtonPriority.secondary : ButtonPriority.basicSecondary}
            className={st(classes.option, { selected: isSelected })}
            data-hook={VIEWER_HOOKS.PLAN_VARIANT_TOGGLE_OPTION}
            title={label}
            onClick={() => onSelect(variant)}
          >
            <span className={classes.label}>{label}</span>
          </Button>
        );
      })}
    </div>
  );
};
